import { Component, Input, SimpleChanges } from '@angular/core';
import { FaqContentfulSectionComponent } from '@features/faq/faq-contentful-section/faq-contentful-section.component';
import {
    Configurations,
    LazyPictureComponent,
    Stops,
} from '@features/lazy-image/components/lazy-picture/lazy-picture.component';
import { Asset, Faq } from '@generated/graphql';
import { NewsletterComponent } from '@shared/newsletter/newsletter/newsletter.component';

@Component({
    selector: 'app-home-faq-newsletter-section',
    imports: [
        LazyPictureComponent,
        FaqContentfulSectionComponent,
        NewsletterComponent,
    ],
    templateUrl: './home-faq-newsletter-section.component.html',
    styleUrls: ['./home-faq-newsletter-section.component.css'],
})
export class HomeFaqNewsletterSectionComponent {
    @Input() faqs: Faq[] = [];
    @Input() faqBackgroundImage: Asset;
    featuredImageConfiguration: Configurations;

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.faqBackgroundImage &&
            changes.faqBackgroundImage.currentValue
        ) {
            this.featuredImageConfiguration = {
                [Stops.FALLBACK]: {
                    image: this.faqBackgroundImage,
                    ratioHeight: 2,
                    ratioWidth: 1,
                    width: 1200,
                    width2x: 1200,
                    focus: 'bottom_right',
                },
                [Stops.BASE]: {
                    image: this.faqBackgroundImage,
                    ratioHeight: 2,
                    ratioWidth: 1,
                    width: 400,
                    width2x: 800,
                    focus: 'center',
                },
                [Stops.MD]: {
                    image: this.faqBackgroundImage,
                    ratioHeight: 2,
                    ratioWidth: 1,
                    width: 800,
                    width2x: 1600,
                    focus: 'center',
                },
                [Stops.LG]: {
                    image: this.faqBackgroundImage,
                    ratioHeight: 2,
                    ratioWidth: 1,
                    width: 1024,
                    width2x: 1600,
                    focus: 'center',
                },
                [Stops.XL]: {
                    image: this.faqBackgroundImage,
                    ratioHeight: 2,
                    ratioWidth: 1,
                    width: 1200,
                    width2x: 1600,
                    focus: 'center',
                },
                [Stops.XXL]: {
                    image: this.faqBackgroundImage,
                    ratioHeight: 1,
                    ratioWidth: 1,
                    width: 1920,
                    width2x: 3840,
                    focus: 'center',
                },
            };
        }
    }
}
